import base from "./base";

export interface APIFeedback {
  data: {
    status: "OK";
  };
}
export const feedback = (name: string, email: string, message: string) =>
  base.post<APIFeedback>(`contact/`, { json: { name, email, message } });
